import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import NavMain from './NavMain';
import NavSub from './NavSub';
// import OutputFileTable from './OutputFileTable';
import ReviewPlace from './ReviewPlace';
import { loadFiles, getOutputReviewStatusGroup, setOutputFileAttribute, getMilestones } from './thunks';
import { setReviewInfo } from './actions';

import 'bootstrap/dist/css/bootstrap.min.css';
import './AppBaseHome.css';
import './AppViewHome.css';

const AppHome = ({ 
  files = [], startLoadingFiles, 
  startSetReviewInfo, startGetOutputReviewStatusGroup, startGetMilestones,
  userInfo, reviewInfo, startSetOutputFileAttribute }) => {
  
  let paramsText = window.location && window.location.search;
  paramsText = paramsText && paramsText.substring(1);
  let params = {};
  try {
    params = JSON.parse(
      '{"' + decodeURI(paramsText).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
  } catch(e) {
    console.log('error in parsing params');
  }
  params['type'] = 'output';
  
  useEffect(() => {
    // console.log('--> useEffect params', params);
    startLoadingFiles(params);
    startGetMilestones(params);
    startSetReviewInfo(params);
    startGetOutputReviewStatusGroup(params.groupId);
  }, 
  // eslint-disable-next-line
  []);
  
  const content = (
    <div className="AppHome">
      <NavMain mode={"view"} />
      <NavSub mode={"view"} />
      <Container fluid>
        <Row>
          <Col md={12} className="MainContent">
            <ReviewPlace allowEdit={false} />
          </Col>
        </Row>
      </Container>
    </div>
  );
  
  return content;
};

const mapState = state => ({
  files: state.files,
  userInfo: state.userInfo,
  reviewInfo: state.reviewInfo,
})

const mapDispatch = dispatch => ({
  startLoadingFiles: (data) => dispatch(loadFiles(data)),
  startGetMilestones: (data) => dispatch(getMilestones(data)),
  startSetReviewInfo: (data) => dispatch(setReviewInfo(data)),
  startGetOutputReviewStatusGroup: (data) => dispatch(getOutputReviewStatusGroup(data)),
  startSetOutputFileAttribute: (data) => dispatch(setOutputFileAttribute(data)),
})

export default connect(mapState, mapDispatch)(AppHome);
